import { createContext, useContext, useEffect, useState } from "react";

const es = {
    meta: {
        title: "Yerberia Jardin D'Venuz | Yerbería en Phoenix AZ · Tarot, Limpias y Veladoras Personalizadas",
        desc: "Yerberia Jardin D'Venuz en Phoenix, Arizona. Más de 40 años de experiencia espiritual: lectura de tarot, cartas españolas, runas, limpias energéticas, veladoras personalizadas y productos espirituales. Atención en español e inglés. Llama al (602) 296-7935.",
        ogTitle: "Yerberia Jardin D'Venuz | Yerbería y Tienda Espiritual en Phoenix AZ",
        ogDesc: "Más de 40 años de experiencia espiritual. Tarot, cartas españolas, runas, limpias energéticas y veladoras personalizadas en Phoenix, AZ. Español & English.",
    },
    nav: {
        inicio: "Inicio", servicios: "Servicios", productos: "Productos", velas: "Velas",
        nosotros: "Nosotros", ubicacion: "Ubicación", contacto: "Contacto", cta: "Agenda tu cita",
    },
    hero: {
        eyebrow: "Más de 40 años de experiencia espiritual",
        subtitle: "Tu camino. Tu luz. Tu destino.",
        servicesLine: "Tarot • Cartas Españolas • Runas • Limpias Energéticas • Veladoras Personalizadas",
        desc: "Un espacio dedicado a la orientación espiritual, energía, protección y bienestar.",
        availability: "Atención presencial en Phoenix y consultas por videollamada · Español & English",
        ctaCall: "Llamar",
        ctaBook: "Reservar lectura",
        ctaMessage: "Enviar mensaje",
        ctaDirections: "Cómo llegar",
        candleLink: "¿Buscas una veladora personalizada? Descúbrela aquí",
    },
    services: {
        eyebrow: "Orientación · Tradición · Bienestar",
        title: "Lecturas y Servicios Espirituales",
        intro: "Lectura de tarot, cartas españolas, runas y limpias energéticas en Phoenix, Arizona. Atención en español e inglés, presencial y por videollamada.",
        cta: "Consultar / Agendar",
        banner1: "Martes y Viernes · Día de Limpias Energéticas",
        banner2: "¡No se ocupa cita!",
        banner3: "Limpieza de malas energías · Protección · Abre caminos · Sanación espiritual · Equilibrio y armonía",
        items: [
            { id: "tarot", title: "Lectura de Tarot", desc: "Explora las situaciones que rodean tu camino y recibe orientación para reflexionar sobre tus próximos pasos." },
            { id: "cartas", title: "Cartas Españolas", desc: "Una lectura tradicional enfocada en relaciones, decisiones, caminos y situaciones personales." },
            { id: "runas", title: "Lectura de Runas", desc: "Símbolos ancestrales utilizados como herramienta de introspección y orientación espiritual." },
            { id: "mano", title: "Lectura de Mano", desc: "Una interpretación de las líneas y características de tus manos desde la tradición de la quiromancia." },
            { id: "astrologia", title: "Astrología", desc: "Descubre la influencia de los astros en tu camino a través de la lectura de tu carta astral." },
            { id: "consejeria", title: "Consejería Espiritual y Matrimonial", desc: "Acompañamiento espiritual para ti y tu familia: personas que enfrentan adicciones, hijos, esposos y parejas. Sanación, oración y diferentes técnicas de orientación." },
            { id: "numerologia", title: "Numerología", desc: "Descubre el simbolismo asociado con los números presentes en tu nombre y fecha de nacimiento." },
            { id: "limpias", title: "Limpias Energéticas", desc: "Rituales espirituales tradicionales enfocados en renovación, armonía y bienestar." },
            { id: "proteccion", title: "Protección y Guía Espiritual", desc: "Servicios personalizados de orientación espiritual de acuerdo con cada situación." },
            { id: "videollamadas", title: "Videollamadas", desc: "Consulta privada desde cualquier lugar del mundo. Comunícate para conocer disponibilidad." },
        ],
    },
    products: {
        eyebrow: "Se vende todo tipo de artículos espirituales",
        title: "Artículos Espirituales",
        intro: "Visita nuestra tienda espiritual en Phoenix y explora los productos disponibles para tu práctica y tu intención.",
        items: ["Libros", "Inciensos", "Veladoras y Veladoras Preparadas", "Jabones Esotéricos", "Cuarzos", "Rosarios", "Salvias", "Amuletos y Talismanes", "Pulseras de Protección"],
        cta: "Preguntar por productos",
    },
    candle: {
        title: "Velas Personalizadas",
        subtitle: "Preparadas especialmente para ti y tu intención.",
        intro: "Cada vela se prepara de forma personalizada utilizando la información que nos proporcionas y la intención que deseas trabajar, tomando en cuenta tu signo, tu elemento y tu planeta.",
        f: {
            nombre: "Nombre completo", fecha: "Fecha de nacimiento", signo: "Signo zodiacal",
            telefono: "Número de teléfono", email: "Correo electrónico (opcional)",
            paraQuien: "¿Para quién es la vela?", intencion: "¿Qué deseas trabajar?",
            situacion: "Cuéntanos brevemente qué necesitas",
            entrega: "¿Prefieres recogerla en nuestra tienda o necesitas envío?",
            direccion: "Dirección de envío", ciudad: "Ciudad", estado: "Estado", cp: "C.P.",
            confirm: "Confirmo que la información proporcionada es correcta.",
        },
        ph: {
            nombre: "Tu nombre completo", situacion: "Describe tu situación o la intención que deseas trabajar…",
            email: "tu@correo.com", direccion: "Calle y número",
        },
        selectSign: "Selecciona tu signo",
        opt: { paraMi: "Para mí", otra: "Para otra persona", recoger: "Recoger en tienda", envio: "Envío" },
        intenciones: ["Amor", "Unión", "Prosperidad", "Abundancia", "Protección", "Limpieza", "Apertura de caminos", "Armonía", "Trabajo / Negocios", "Bienestar", "Otro"],
        signos: ["Aries", "Tauro", "Géminis", "Cáncer", "Leo", "Virgo", "Libra", "Escorpio", "Sagitario", "Capricornio", "Acuario", "Piscis"],
        submit: "Solicitar mi vela personalizada",
        note: "Tu solicitud se enviará por WhatsApp. La vela es un acompañamiento espiritual; no se garantiza ningún resultado específico.",
        toastErr: "Por favor completa: ",
        toastOk: "Tu solicitud está lista. Se abrió WhatsApp para enviarla.",
        wa: {
            intro: "Hola, quiero solicitar una vela personalizada.",
            name: "Nombre", dob: "Fecha de nacimiento", sign: "Signo", forWhom: "La vela es",
            intention: "Intención", situation: "Situación", delivery: "Recoger/Envío",
            shipAddress: "Dirección de envío", phone: "Teléfono", email: "Correo",
        },
    },
    how: {
        eyebrow: "El Proceso",
        title: "Cómo Funciona",
        steps: [
            { title: "Cuéntanos tu intención", desc: "Envía tu nombre, signo y lo que deseas trabajar." },
            { title: "Personalizamos tu vela", desc: "Se prepara de acuerdo con la información proporcionada." },
            { title: "Recibe confirmación", desc: "Nos comunicaremos contigo para confirmar detalles, precio y tiempo de preparación." },
            { title: "Recoge o recibe tu pedido", desc: "Recoge tu vela en Phoenix o consulta las opciones de envío disponibles." },
        ],
    },
    guidance: {
        title: "¿Necesitas respuestas, claridad o dirección?",
        text: "Recibe atención privada, respetuosa y personalizada en un ambiente dedicado a la orientación espiritual.",
        keywords: ["Conexión", "Guía", "Protección", "Transformación"],
        cta: "Hablar por WhatsApp",
        caption: "Estoy aquí para ayudarte",
    },
    reviews: {
        eyebrow: "Confianza · Respeto · Discreción",
        title: "Reseñas de Nuestros Clientes",
        text: "La confianza de nuestra comunidad es nuestro mayor aval. Lee las reseñas verificadas de nuestros clientes directamente en Google.",
        googleCta: "Ver reseñas en Google",
        shareCta: "Comparte tu experiencia",
    },
    about: {
        title: "Un espacio para tu camino espiritual",
        p1: "Yerberia Jardin D'Venuz es un espacio en Phoenix dedicado a productos, tradiciones y servicios espirituales, con más de 40 años de experiencia. Nuestro objetivo es ofrecer atención personalizada en un ambiente privado, respetuoso y discreto.",
        p2: "Somos una tienda abierta a recibir todo tipo de clientes. Sin promesas falsas: se te dice con honestidad en lo que tienes que trabajar y te ayudamos en el proceso, todo espiritualmente.",
        p3: "Todo es personalizado: velas, amuletos, limpias y más, de acuerdo a tu signo, tu elemento, tu planeta y los recursos que concuerden contigo.",
        disclaimer: "Nuestros servicios son de carácter espiritual y personal. No sustituyen asesoría médica, psicológica, legal o financiera profesional.",
        galleryLabel: "Nuestra Tienda",
    },
    location: {
        eyebrow: "Visítanos",
        title: "Ubicación y Contacto",
        hours: "Horario",
        monFri: "Lunes a Viernes",
        sat: "Sábado",
        sun: "Domingo",
        closed: "Cerrado",
        languages: "Atención en Español e Inglés",
        parking: "Estacionamiento disponible",
        call: "Llamar",
        directions: "Cómo llegar",
        caption: "Citas y consultas por WhatsApp o mensaje de texto · Videollamadas en todos los países",
        mapTitle: "Mapa de Yerberia Jardin D'Venuz, 4124 N 19th Ave, Phoenix, AZ 85015",
    },
    social: {
        eyebrow: "Comunidad",
        title: "Síguenos y descubre más",
    },
    footer: {
        disclaimer: "Los servicios espirituales ofrecidos son de carácter personal y espiritual, y se ofrecen como orientación para el crecimiento personal. Los resultados pueden variar y no se garantiza ningún resultado específico. Ningún servicio sustituye asesoría médica, psicológica, legal o financiera profesional.",
        copyright: "Copyright © 2026 Yerberia Jardin D'Venuz.",
        hoursTitle: "Horario",
        privacy: "Política de Privacidad",
        terms: "Términos de Uso",
        home: "Volver al inicio",
    },
    cookie: {
        text: "Utilizamos cookies de análisis para mejorar tu experiencia. Al continuar navegando, aceptas su uso.",
        accept: "Aceptar",
    },
    float: { tooltip: "Habla con nosotros" },
    mobile: { llamar: "Llamar", mensaje: "Mensaje", reservar: "Reservar" },
    wa: {
        appointment: "Hola, quiero agendar una cita en Yerberia Jardin D'Venuz.",
        book: "Hola, quiero reservar una lectura en Yerberia Jardin D'Venuz.",
        message: "Hola, quiero más información sobre sus servicios.",
        guidance: "Hola, necesito orientación espiritual. Me gustaría recibir más información.",
        products: "Hola, quiero información sobre los artículos espirituales disponibles en la tienda.",
        reviewShare: "Hola, quiero compartir mi experiencia con Yerberia Jardin D'Venuz.",
        servicePrefix: "Hola, me interesa el servicio de ",
        serviceSuffix: ". ¿Podrían darme más información para consultar o agendar?",
    },
    legal: {
        privacy: {
            title: "Política de Privacidad",
            updated: "Última actualización: septiembre 2026",
            sections: [
                { h: "Información que recopilamos", p: "Cuando nos contactas por WhatsApp, teléfono o mediante el formulario de velas personalizadas, recibimos la información que decides compartir, como tu nombre, número de teléfono, fecha de nacimiento y la intención que deseas trabajar. Esta información se utiliza únicamente para atender tu solicitud." },
                { h: "Uso de la información", p: "Tu información se usa para preparar servicios personalizados, responder tus mensajes y coordinar citas o entregas. No vendemos ni compartimos tu información personal con terceros con fines comerciales." },
                { h: "Cookies y análisis", p: "Este sitio utiliza herramientas de análisis que pueden usar cookies para entender cómo los visitantes usan la página y mejorar la experiencia. Puedes desactivar las cookies en la configuración de tu navegador." },
                { h: "Contacto", p: "Si tienes preguntas sobre esta política o deseas que eliminemos tu información, contáctanos al (602) 296-7935 o visita nuestra tienda en 4124 N 19th Ave, Phoenix, AZ 85015." },
            ],
        },
        terms: {
            title: "Términos de Uso",
            updated: "Última actualización: septiembre 2026",
            sections: [
                { h: "Servicios espirituales", p: "Los servicios ofrecidos por Yerberia Jardin D'Venuz son de carácter personal y espiritual, y se ofrecen como orientación para el crecimiento personal y la reflexión." },
                { h: "Sin garantías", p: "No se garantiza ningún resultado específico. Ningún servicio sustituye asesoría médica, psicológica, legal o financiera profesional. Si enfrentas una situación de salud, legal o financiera, consulta a un profesional licenciado." },
                { h: "Uso del sitio", p: "El contenido de este sitio es informativo. Al enviar el formulario de velas personalizadas, confirmas que la información proporcionada es correcta. Los pedidos se confirman directamente con la tienda, incluyendo precio y tiempo de preparación." },
                { h: "Contacto", p: "Yerberia Jardin D'Venuz, 4124 N 19th Ave, Phoenix, AZ 85015 · (602) 296-7935." },
            ],
        },
    },
};

const en = {
    meta: {
        title: "Yerberia Jardin D'Venuz | Spiritual Store in Phoenix AZ · Tarot, Cleansings & Personalized Candles",
        desc: "Spiritual shop in Phoenix, Arizona with 40+ years of experience: tarot readings, Spanish cards, rune readings, energy cleansings, personalized spiritual candles and esoteric products. Service in English and Spanish. Call (602) 296-7935.",
        ogTitle: "Yerberia Jardin D'Venuz | Spiritual Store & Yerbería in Phoenix AZ",
        ogDesc: "Over 40 years of spiritual experience. Tarot, Spanish cards, runes, energy cleansings and personalized candles in Phoenix, AZ. English & Spanish.",
    },
    nav: {
        inicio: "Home", servicios: "Services", productos: "Products", velas: "Candles",
        nosotros: "About", ubicacion: "Location", contacto: "Contact", cta: "Book Now",
    },
    hero: {
        eyebrow: "Over 40 years of spiritual experience",
        subtitle: "Your path. Your light. Your destiny.",
        servicesLine: "Tarot • Spanish Cards • Runes • Energy Cleansings • Personalized Candles",
        desc: "A space devoted to spiritual guidance, energy, protection and well-being.",
        availability: "In-person service in Phoenix and video call consultations · Español & English",
        ctaCall: "Call Now",
        ctaBook: "Book a Reading",
        ctaMessage: "Send a Message",
        ctaDirections: "Get Directions",
        candleLink: "Looking for a personalized candle? Discover it here",
    },
    services: {
        eyebrow: "Guidance · Tradition · Well-being",
        title: "Spiritual Readings & Services",
        intro: "Tarot readings, Spanish cards, rune readings and energy cleansings in Phoenix, Arizona. Service in English and Spanish, in person and by video call.",
        cta: "Ask / Book",
        banner1: "Tuesdays & Fridays · Energy Cleansing Days",
        banner2: "No appointment needed!",
        banner3: "Cleansing of negative energy · Protection · Open roads · Spiritual healing · Balance and harmony",
        items: [
            { id: "tarot", title: "Tarot Reading", desc: "Explore the situations surrounding your path and receive guidance to reflect on your next steps." },
            { id: "cartas", title: "Spanish Cards", desc: "A traditional reading focused on relationships, decisions, paths and personal situations." },
            { id: "runas", title: "Rune Reading", desc: "Ancestral symbols used as a tool for introspection and spiritual guidance." },
            { id: "mano", title: "Palm Reading", desc: "An interpretation of the lines and features of your hands from the tradition of palmistry." },
            { id: "astrologia", title: "Astrology", desc: "Discover the influence of the stars on your path through a reading of your birth chart." },
            { id: "consejeria", title: "Spiritual & Marriage Counseling", desc: "Spiritual support for you and your family: people facing addictions, children, spouses and couples. Healing, prayer and different guidance techniques." },
            { id: "numerologia", title: "Numerology", desc: "Discover the symbolism behind the numbers in your name and date of birth." },
            { id: "limpias", title: "Energy Cleansings", desc: "Traditional spiritual rituals focused on renewal, harmony and well-being." },
            { id: "proteccion", title: "Spiritual Protection & Guidance", desc: "Personalized spiritual guidance services according to each situation." },
            { id: "videollamadas", title: "Video Calls", desc: "Private consultation from anywhere in the world. Contact us to check availability." },
        ],
    },
    products: {
        eyebrow: "We sell all kinds of spiritual items",
        title: "Spiritual Products",
        intro: "Visit our spiritual store in Phoenix and explore the products available for your practice and your intention.",
        items: ["Books", "Incense", "Ritual & Prepared Candles", "Esoteric Soaps", "Crystals", "Rosaries", "Sage", "Amulets & Talismans", "Protection Bracelets"],
        cta: "Ask About Products",
    },
    candle: {
        title: "Personalized Candles",
        subtitle: "Prepared especially for you and your intention.",
        intro: "Each candle is prepared in a personalized way using the information you provide and the intention you wish to work on, taking into account your sign, your element and your planet.",
        f: {
            nombre: "Full name", fecha: "Date of birth", signo: "Zodiac sign",
            telefono: "Phone number", email: "Email (optional)",
            paraQuien: "Who is this candle for?", intencion: "What would you like to work on?",
            situacion: "Briefly tell us what you need",
            entrega: "Would you rather pick it up at our store or have it shipped?",
            direccion: "Shipping address", ciudad: "City", estado: "State", cp: "ZIP",
            confirm: "I confirm that the information provided is correct.",
        },
        ph: {
            nombre: "Your full name", situacion: "Describe your situation or the intention you wish to work on…",
            email: "you@email.com", direccion: "Street and number",
        },
        selectSign: "Select your sign",
        opt: { paraMi: "For me", otra: "For someone else", recoger: "Pick up in store", envio: "Shipping" },
        intenciones: ["Love", "Union", "Prosperity", "Abundance", "Protection", "Cleansing", "Open Roads", "Harmony", "Work / Business", "Well-being", "Other"],
        signos: ["Aries", "Taurus", "Gemini", "Cancer", "Leo", "Virgo", "Libra", "Scorpio", "Sagittarius", "Capricorn", "Aquarius", "Pisces"],
        submit: "Request My Personalized Candle",
        note: "Your request will be sent by WhatsApp. A candle is a spiritual companion; no specific outcome is guaranteed.",
        toastErr: "Please complete: ",
        toastOk: "Your request is ready. WhatsApp opened so you can send it.",
        wa: {
            intro: "Hello, I would like to request a personalized candle.",
            name: "Name", dob: "Date of birth", sign: "Zodiac sign", forWhom: "This candle is",
            intention: "Intention", situation: "Situation", delivery: "Pickup/Shipping",
            shipAddress: "Shipping address", phone: "Phone", email: "Email",
        },
    },
    how: {
        eyebrow: "The Process",
        title: "How It Works",
        steps: [
            { title: "Tell us your intention", desc: "Send your name, sign and what you wish to work on." },
            { title: "We personalize your candle", desc: "It is prepared according to the information provided." },
            { title: "Receive confirmation", desc: "We will contact you to confirm details, price and preparation time." },
            { title: "Pick up or receive your order", desc: "Pick up your candle in Phoenix or ask about available shipping options." },
        ],
    },
    guidance: {
        title: "Need answers, clarity or direction?",
        text: "Receive private, respectful and personalized attention in a space devoted to spiritual guidance.",
        keywords: ["Connection", "Guidance", "Protection", "Transformation"],
        cta: "Chat on WhatsApp",
        caption: "I am here to help you",
    },
    reviews: {
        eyebrow: "Trust · Respect · Discretion",
        title: "What Our Clients Say",
        text: "Our community's trust is our greatest credential. Read our clients' verified reviews directly on Google.",
        googleCta: "Read Reviews on Google",
        shareCta: "Share Your Experience",
    },
    about: {
        title: "A space for your spiritual path",
        p1: "Yerberia Jardin D'Venuz is a space in Phoenix devoted to spiritual products, traditions and services, with over 40 years of experience. Our goal is to offer personalized attention in a private, respectful and discreet environment.",
        p2: "We are a store open to every kind of client. No false promises: you are told honestly what you need to work on, and we help you through the process, all spiritually.",
        p3: "Everything is personalized: candles, amulets, cleansings and more, according to your sign, your element, your planet and the resources that align with you.",
        disclaimer: "Our services are spiritual and personal in nature. They do not replace professional medical, psychological, legal or financial advice.",
        galleryLabel: "Our Store",
    },
    location: {
        eyebrow: "Visit Us",
        title: "Location & Contact",
        hours: "Hours",
        monFri: "Monday to Friday",
        sat: "Saturday",
        sun: "Sunday",
        closed: "Closed",
        languages: "Service in English & Spanish",
        parking: "Parking available",
        call: "Call",
        directions: "Get Directions",
        caption: "Appointments and consultations by WhatsApp or text message · Video calls available worldwide",
        mapTitle: "Map of Yerberia Jardin D'Venuz, 4124 N 19th Ave, Phoenix, AZ 85015",
    },
    social: {
        eyebrow: "Community",
        title: "Follow Us and Discover More",
    },
    footer: {
        disclaimer: "The spiritual services offered are personal and spiritual in nature and are provided as guidance for personal growth. Results may vary and no specific outcome is guaranteed. No service replaces professional medical, psychological, legal or financial advice.",
        copyright: "Copyright © 2026 Yerberia Jardin D'Venuz.",
        hoursTitle: "Hours",
        privacy: "Privacy Policy",
        terms: "Terms of Use",
        home: "Back to home",
    },
    cookie: {
        text: "We use analytics cookies to improve your experience. By continuing to browse, you accept their use.",
        accept: "Accept",
    },
    float: { tooltip: "Chat with us" },
    mobile: { llamar: "Call", mensaje: "Message", reservar: "Book" },
    wa: {
        appointment: "Hello, I would like to book an appointment at Yerberia Jardin D'Venuz.",
        book: "Hello, I would like to book a reading at Yerberia Jardin D'Venuz.",
        message: "Hello, I would like more information about your services.",
        guidance: "Hello, I am seeking spiritual guidance. I would like to receive more information.",
        products: "Hello, I would like information about the spiritual items available in the store.",
        reviewShare: "Hello, I would like to share my experience with Yerberia Jardin D'Venuz.",
        servicePrefix: "Hello, I am interested in the following service: ",
        serviceSuffix: ". Could you give me more information so I can ask a question or book?",
    },
    legal: {
        privacy: {
            title: "Privacy Policy",
            updated: "Last updated: September 2026",
            sections: [
                { h: "Information we collect", p: "When you contact us by WhatsApp, phone or through the personalized candle form, we receive the information you choose to share, such as your name, phone number, date of birth and the intention you wish to work on. This information is used only to handle your request." },
                { h: "How we use information", p: "Your information is used to prepare personalized services, answer your messages and coordinate appointments or deliveries. We do not sell or share your personal information with third parties for commercial purposes." },
                { h: "Cookies and analytics", p: "This site uses analytics tools that may use cookies to understand how visitors use the page and to improve the experience. You can disable cookies in your browser settings." },
                { h: "Contact", p: "If you have questions about this policy or would like us to delete your information, contact us at (602) 296-7935 or visit our store at 4124 N 19th Ave, Phoenix, AZ 85015." },
            ],
        },
        terms: {
            title: "Terms of Use",
            updated: "Last updated: September 2026",
            sections: [
                { h: "Spiritual services", p: "The services offered by Yerberia Jardin D'Venuz are personal and spiritual in nature and are provided as guidance for personal growth and reflection." },
                { h: "No guarantees", p: "No specific outcome is guaranteed. No service replaces professional medical, psychological, legal or financial advice. If you are facing a health, legal or financial situation, please consult a licensed professional." },
                { h: "Use of this site", p: "The content of this site is informational. By submitting the personalized candle form, you confirm that the information provided is accurate. Orders are confirmed directly with the store, including price and preparation time." },
                { h: "Contact", p: "Yerberia Jardin D'Venuz, 4124 N 19th Ave, Phoenix, AZ 85015 · (602) 296-7935." },
            ],
        },
    },
};

const dictionaries = { es, en };

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => localStorage.getItem("jdv-lang") || "es");
    const t = (key) =>
        key.split(".").reduce((obj, k) => (obj == null ? undefined : obj[k]), dictionaries[lang]) ?? key;

    useEffect(() => {
        localStorage.setItem("jdv-lang", lang);
        document.documentElement.lang = lang;
        const m = dictionaries[lang].meta;
        document.title = m.title;
        const setMeta = (attr, name, content) => {
            const el = document.querySelector(`meta[${attr}="${name}"]`);
            if (el) el.setAttribute("content", content);
        };
        setMeta("name", "description", m.desc);
        setMeta("property", "og:title", m.ogTitle);
        setMeta("property", "og:description", m.ogDesc);
        setMeta("name", "twitter:title", m.ogTitle);
        setMeta("name", "twitter:description", m.ogDesc);
    }, [lang]);

    return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
